(() => {
  if (window.runzieBundleCartLoaded) return;
  window.runzieBundleCartLoaded = true;
  const selector = '[data-essential-cart-element="line-item-properties"]';
  const normalize = value => String(value).replace(/\s+/g, ' ').trim();
  let pending = null, lastFetch = 0;
  const lines = new Map();
  const signatures = new WeakMap();
  function remember(items) {
    for (const item of items || []) {
      const props = item.properties || {};
      if (!props._runzie_bundle_items) continue;
      const key = JSON.stringify(Object.entries(props).filter(([k]) => k === 'Bundle' || /^Item \d+$/.test(k)).sort());
      lines.set(key, {properties: props});
    }
    while (lines.size > 100) lines.delete(lines.keys().next().value);
  }
  try { remember(JSON.parse(document.getElementById('RunzieBundleCartSeed')?.textContent || '[]')); } catch (_) {}
  function refresh() {
    if (pending || Date.now() - lastFetch < 1500) return;
    lastFetch = Date.now();
    pending = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}})
      .then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .then(data => { remember(data.items); update(false); })
      .catch(() => {}).finally(() => pending = null);
  }
  function itemsFor(line) {
    try {
      const items = JSON.parse(line.properties._runzie_bundle_items);
      if (!Array.isArray(items) || !items.length || items.length > 20) return null;
      const grouped = new Map();
      for (const x of items) {
        if (!x || typeof x.title !== 'string' || typeof x.variant !== 'string' || !/^\d+$/.test(x.id)) return null;
        const key = `${x.id}:${x.variant}`;
        if (grouped.has(key)) grouped.get(key).quantity++;
        else grouped.set(key, {...x, quantity:1});
      }
      return [...grouped.values()];
    } catch (_) { return null; }
  }
  function build(items) {
    const box = document.createElement('div'); box.className = 'rz-bundle-cart';
    const heading = document.createElement('p'); heading.className = 'rz-bundle-cart__heading'; heading.textContent = 'IN EACH BUNDLE'; box.append(heading);
    const list = document.createElement('ul'); box.append(list);
    items.forEach(item => {
      const row = document.createElement('li');
      try {
        const url = new URL(item.image, location.origin);
        if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopify.com'))) {
          const img = document.createElement('img'); img.src = url.href; img.alt = item.title; img.loading = 'eager'; img.width = 56; img.height = 70; row.append(img);
        }
      } catch (_) {}
      const info = document.createElement('div'); info.className = 'rz-bundle-cart__info';
      const title = document.createElement('p'); title.className = 'rz-bundle-cart__name'; title.textContent = item.title;
      const variant = document.createElement('p'); variant.className = 'rz-bundle-cart__variant'; variant.textContent = item.variant === 'Default Title' ? 'Standard' : item.variant;
      const qty = document.createElement('span'); qty.className = 'rz-bundle-cart__qty'; qty.textContent = `×${item.quantity}`;qty.setAttribute('aria-label',`Quantity ${item.quantity} in each bundle`);
      info.append(title,variant); row.append(info,qty); list.append(row);
    });
    return box;
  }
  function update(allowFetch = true) {
    let missing = false;
    document.querySelectorAll(selector).forEach(node => {
      if (!/Item\s+\d+\s*:/.test(node.textContent)) return;
      const texts = [...node.children].map(x => normalize(x.textContent));
      const line = [...lines.values()].find(item => {
        const entries = Object.entries(item.properties).filter(([key]) => key === 'Bundle' || /^Item \d+$/.test(key));
        return entries.length > 1 && entries.every(([key,value]) => texts.includes(normalize(`${key}: ${value}`)));
      });
      const existing = node.nextElementSibling?.classList.contains('rz-bundle-cart') ? node.nextElementSibling : null;
      if (!line) {
        missing = true; existing?.remove();
        [...node.children].forEach(c => c.classList.remove('rz-bundle-cart-original'));
        signatures.delete(node); return;
      }
      const items = itemsFor(line); if (!items) return;
      const signature = line.properties._runzie_bundle_items;
      if (!existing || signatures.get(node) !== signature) {
        existing?.remove(); node.after(build(items)); signatures.set(node,signature);
      }
      [...node.children].forEach(child => {
        if (/^(Bundle|Item \d+)\s*:/.test(normalize(child.textContent))) child.classList.add('rz-bundle-cart-original');
      });
    });
    if (missing && allowFetch) refresh();
  }
  // MutationObserver runs before paint: rebuild from in-memory data without a timer or network wait.
  new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('.rz-bundle-cart') && (record.type === 'characterData' || [...record.addedNodes,...record.removedNodes].some(n => !(n.nodeType === 1 && n.classList.contains('rz-bundle-cart')))))) update();
  }).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  document.addEventListener('runzie:bundle-prepared', e => { remember([e.detail]); update(false); });
  ['product-ajax:added','cart:updated','cart:refresh'].forEach(name => document.addEventListener(name,e => {
    if (e.detail?.product) remember([e.detail.product]);
    if (e.detail?.cart?.items) remember(e.detail.cart.items);
    update();
  }));
  update();
})();
